export default __webpack_public_path__ + "static/media/chronometer.a295771c.svg";